import React, { Component } from 'react'
import { VulnerabilityPoliciesLoader } from './vulnerability-policies-loader'
import { ViewerLoader } from '../viewer'
import { VulnerabilityPoliciesGridManager } from './vulnerability-policies-grid-manager'
import { ConfigurationPanel } from '../../legacy-design-system/configuration-panel'
import {
  TabGroupToggle,
  TabItemProps
} from '../../legacy-design-system/tab-group-toggle'
import { css } from '@emotion/css'
import { VulnerabilityPolicyAction } from './index'
import { I18nConsumer } from '../i18n-provider'
import { getVulnerabilityPolicyActionOnCancelFromLocation } from '../route/current-route'
import { updateRoute } from '../route'
import { Role } from '@contrast-security-inc/base-types'

// TODO RBAR include test after implementing CONTRAST-38141
export function VulnerabilityPoliciesManager() {
  return (
    <ViewerLoader>
      {({ viewer, loading }) => {
        return (
          !loading &&
          !!viewer && (
            <ConfigurationPanel title="title_vulnerabilityPolicy">
              <WrappedVulnerabilityPolicies
                organizationID={viewer.currentOrganization.id}
                organizationRole={viewer.currentOrganization.role}
              />
            </ConfigurationPanel>
          )
        )
      }}
    </ViewerLoader>
  )
}

const tabConfig: Array<TabItemProps<VulnerabilityPolicyAction>> = [
  {
    id: 'AUTO_REMEDIATE',
    label: 'title_vulnerabilityPolicy_typeAutoVerification'
  },
  { id: 'NOTIFY', label: 'title_vulnerabilityPolicy_typeViolation' }
]

const routeToVulnerabilityTabGrid = (
  organizationID: string,
  action: VulnerabilityPolicyAction
) =>
  updateRoute(
    `/${organizationID}/rules/vulnerability-management?action=${action}`
  )

interface WrappedVulnerabilityPoliciesProps {
  readonly organizationID: string
  readonly organizationRole: Role
}

class WrappedVulnerabilityPolicies extends Component<WrappedVulnerabilityPoliciesProps> {
  public render() {
    const action = getVulnerabilityPolicyActionOnCancelFromLocation()

    const { organizationID, organizationRole } = this.props
    const selectedTab =
      action.get('action') && action.get('action') === 'NOTIFY'
        ? tabConfig[1]
        : tabConfig[0]

    return (
      <div>
        <div
          className={css`
            padding: 10px;
          `}
        >
          <I18nConsumer>
            {({ intl }) => (
              <TabGroupToggle<VulnerabilityPolicyAction>
                items={tabConfig.map((config) => ({
                  ...config,
                  label: intl.formatMessage({
                    id: config.label
                  })
                }))}
                selectedItem={selectedTab}
                onSelect={(item) => this.onTabSelected(organizationID, item)}
              />
            )}
          </I18nConsumer>
        </div>

        <VulnerabilityPoliciesLoader
          organizationID={organizationID}
          action={selectedTab.id}
        >
          {({ vulnerabilityPolicies, refetch, loading }) => {
            return selectedTab.id === 'AUTO_REMEDIATE' ? (
              <VulnerabilityPoliciesGridManager
                organizationID={organizationID}
                organizationRole={organizationRole}
                loading={loading}
                refetch={refetch}
                vulnerabilityPolicies={vulnerabilityPolicies}
                action={'AUTO_REMEDIATE'}
              />
            ) : selectedTab.id === 'NOTIFY' ? (
              <VulnerabilityPoliciesGridManager
                organizationID={organizationID}
                organizationRole={organizationRole}
                loading={loading}
                refetch={refetch}
                vulnerabilityPolicies={vulnerabilityPolicies}
                action={'NOTIFY'}
              />
            ) : (
              <div />
            )
          }}
        </VulnerabilityPoliciesLoader>
      </div>
    )
  }

  private onTabSelected(
    organizationID: string,
    item: TabItemProps<VulnerabilityPolicyAction>
  ) {
    routeToVulnerabilityTabGrid(organizationID, item.id)
  }
}
